import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import BASE_URL from '../config';

const useFetchCart = () => {
  const [cart, setCart] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCart = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const isAuthenticated = !!localStorage.getItem('authToken'); 
      const authToken = localStorage.getItem('authToken');
      console.log(authToken)
      
      const headers = {
        'Content-Type': 'application/json',
      };

      if (authToken) {
        headers['Authorization'] = `Token ${authToken}`;
      } else {
        const anonymousUserId = localStorage.getItem('anonymousUserID');
        headers['Anonymous-User-ID'] = anonymousUserId;
      }

      const response = await axios.get(`${BASE_URL}/api/viewcart/`, { headers });
      setCart(response.data);
    } catch (err) {
      setError('Failed to fetch cart');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    console.log('Fetching cart data...');
    fetchCart();
  }, [fetchCart]);

  return { cart, loading, error, fetchCart };
};

export default useFetchCart;
